import { createHash } from 'crypto';

const CIPHER_TF = 'MD5';

export const hash = (obj: object) => {
    const value = JSON.stringify(obj);
    const cipher = createHash(CIPHER_TF);
    cipher.update(value);
    return cipher.digest('hex');
};
